import React from 'react'
import { Alert, Button, Card, Col, Row } from 'reactstrap'
import PageHeader from '../common/PageHeader'
import Loader from '../common/Loader'
import useSWRFetch from '../../helpers/hooks/useSWRFetch'
import { getRewardsSummary } from '../../helpers/api/rewards'
import LevelCard from './components/LevelCard'
import CoinsCard from './components/CoinsCard'
import StreakCard from './components/StreakCard'
import RaffleCard from './components/RaffleCard'
import TransactionsHistory from './components/TransactionsHistory'
import NotificationSettingsCard from './components/NotificationSettingsCard'

// HO-TASK-282: vista principal de Homelan Rewards para el propietario. El
// resumen (nivel, Coins, racha, sorteo) y el historial se piden por separado,
// así paginar el historial no vuelve a cargar las tarjetas de arriba.
const Rewards = () => {
  const { data, error, isLoading, mutate } = useSWRFetch('rewards-summary', getRewardsSummary)
  const summary = data?.data

  const renderSummary = () => {
    if (isLoading) {
      return (
        <Card className="mb-3">
          <Loader padding="py-5" />
        </Card>
      )
    }

    if (error || !summary) {
      return (
        <Alert color="danger" className="mb-3">
          No pudimos cargar tu resumen de Homelan Rewards.
          <Button color="link" size="sm" className="ml-1 p-0 align-baseline" onClick={() => mutate()}>
            Reintentar
          </Button>
        </Alert>
      )
    }

    return (
      <>
        <Row noGutters>
          <Col lg={6} className="mb-3 pr-lg-2">
            <LevelCard summary={summary} />
          </Col>
          <Col lg={6} className="mb-3 pl-lg-2">
            <CoinsCard summary={summary} />
          </Col>
        </Row>
        <Row noGutters>
          <Col md={6} className="mb-3 pr-md-2">
            <StreakCard summary={summary} />
          </Col>
          <Col md={6} className="mb-3 pl-md-2">
            <RaffleCard tickets={summary.raffle_tickets_this_month} />
          </Col>
        </Row>
      </>
    )
  }

  return (
    <>
      <PageHeader
        title="Homelan Rewards"
        titleTag="h2"
        description="Paga tu condominio a tiempo y gana XP para subir de nivel y Homelan Coins que puedes usar para pagar tus cuotas."
        className="mb-3"
        col={{ lg: 9 }}
      />
      {renderSummary()}
      <TransactionsHistory />
      <NotificationSettingsCard />
    </>
  )
}

export default Rewards
